module.exports = __webpack_public_path__ + "static/banner-9cea7ef72889aaaacae20c6da8f7a131.mp4";